import {TargetBlank} from '@wandb/weave/common/util/links';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import DocUrls from '../../../util/doc_urls';
import {CARD_HEIGHT, CARD_MIN_WIDTH} from './DefaultRegistryCard';

export const NewRegistryCard = () => {
  return (
    <Tailwind style={{height: CARD_HEIGHT, minWidth: CARD_MIN_WIDTH}}>
      <div className="h-full w-full rounded border border-moon-200 bg-white p-16">
        <div>
          <div className="align-middle text-base font-semibold leading-8 text-moon-600">
            Create a new registry
          </div>
          <p className="text-pretty whitespace-normal text-sm leading-5 text-moon-500">
            <span>
              Create custom registries tailored to your specific needs,
              effortlessly organizing and sharing your critical ML assets across
              teams.{' '}
            </span>
            <TargetBlank href={DocUrls.registry + 'create_registry'}>
              <span className="font-semibold">Learn more</span>
            </TargetBlank>
          </p>
        </div>
      </div>
    </Tailwind>
  );
};
